module.exports = __webpack_public_path__ + "img/slider_galery_15.8fb8f9fc.jpg";